import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {withIsOpenState} from '../../../../lib/react/higher-order-components';
import {OEMediaType} from '../../../../react-oe/oe-types';
import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../../lib/custom-scrollbar/custom-scrollbar';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import {OEGroupControl, OEIconButtonGroupControl} from '../../../elements/controls/oe-controls';
import OEIcon from '../../../elements/oe-icon';
import OEWidgetHeader from '../../../elements/oe-widget-header';
import OEPopover from '../../../views/oe-popover';
import {OEPopoverMenuButton} from '../../../views/oe-popover-menu';
import {OEFunctionFragmentType, OEFunctionFragmentIcons, OEFunctionShowMediaFlags, OEFunctionProps} from './oe-function-model';
import OEFunctionFragmentCell from './oe-function-fragment-cell';

export class OEFunctionController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.defaultFragmentParams = [
            {id: OEFunctionFragmentType.showMedia, params: {mediaType: OEMediaType.video, flags: OEFunctionShowMediaFlags.def}}
        ];

        this.func = this.sanitizeFunc(this.props.func);

        this.state = {
            addFragmentMenuEntries:    this.constructAddFragmentMenuEntries(),
            func:                       clone(this.func)
        };

        this.onAddFragmentMenuRef = this.onAddFragmentMenuRef.bind(this);

        this.renderHeaderCenterBar = this.renderHeaderCenterBar.bind(this);

        this.onButtonPressed = this.onButtonPressed.bind(this);
        this.onAddFragmentMenuSelection = this.onAddFragmentMenuSelection.bind(this);

        this.onFragmentChange = this.onFragmentChange.bind(this);
        this.onDumpFragmentBtnPressed = this.onDumpFragmentBtnPressed.bind(this);
    }

    constructAddFragmentMenuEntries(props) {
        props = props || this.props;
        if(!Array.isArray(props.addFragmentMenuTypes))    return [];

        let entries = [];
        props.addFragmentMenuTypes.forEach(element => {

            if(typeof(element) == 'number') {
                element = {type: element};
            } else if(typeof(element) !== 'object' || !element)  {
                return;
            }

            //
            let allowMultipleInstances = element.allowMultipleInstances !== undefined ? element.allowMultipleInstances : false;

            //
            if(!allowMultipleInstances && this.func && this.func.fragments.findIndex(attribute => attribute.type === element.type) >= 0)  return;

            //
            let incompatibleTypes = typeof(element.incompatibleTypes) === 'number' ? [element.incompatibleTypes] : element.incompatibleTypes;

            if(Array.isArray(incompatibleTypes) && this.attributes.findIndex(attribute => incompatibleTypes.includes(attribute.type)) >= 0)  return;

            //
            entries.push({
                id:     element.type,
                icon:   OEFunctionFragmentIcons.iconForType(element.type)
            });
        });

        return entries;
    }

    sanitizeFunc(func)  {
        func = clone(func);
        if(!func || Array.isArray(func.fragments))  return func;
        func.fragments = [];
        return func;
    }

    setFunction(func_)   {
        if(typeof(func_) !== 'undefined' && typeof(func_) !== 'object')   return;
        let func = this.sanitizeFunc(func_);
        if(OEToolbox.shallowEqual(func, this.func, true)) return;
        this.func = func;
        this.setState({func: clone(this.func)});
        this.updateAddFragmentMenuEntriesState();
    }

    componentWillReceiveProps(nextProps)    {
        let needsAddFragmentMenuEntriesUpdate = false;

        if(!OEToolbox.shallowEqual(nextProps.func, this.props.func, true))    {
            let func = this.sanitizeFunc(nextProps.func);
            if(!OEToolbox.shallowEqual(func, this.props.func, true))    {
                this.func = func;
                this.setState({func: clone(this.func)});
                needsAddFragmentMenuEntriesUpdate = true;
            }
        }

        if(!needsAddFragmentMenuEntriesUpdate && !OEToolbox.shallowEqual(nextProps.addFragmentMenuTypes, this.props.addFragmentMenuTypes, true)) {
            needsAddFragmentMenuEntriesUpdate = true;
        }

        if(needsAddFragmentMenuEntriesUpdate)   {
            this.updateAddFragmentMenuEntriesState(nextProps);
        }
    }

    updateAddFragmentMenuEntriesState(props) {
        let addFragmentMenuEntries = this.constructAddFragmentMenuEntries(props);
        this.setState({addFragmentMenuEntries: addFragmentMenuEntries});
        if(!addFragmentMenuEntries.length && this.addFragmentMenuRef)   this.addFragmentMenuRef.close();
    }

    onAddFragmentMenuRef(ref)   {
        this.addFragmentMenuRef = ref;
    }

    renderHeaderCenterBar(props)    {
        if(!this.props.addButtonInHeader)    return null;

        return (
            <OEPopoverMenuButton
                className="transparent-btn add-fragment-btn"
                popoverClassName="with-backdrop"
                controllerClassName="add-function-fragment-menu"
                placement="top"
                boundariesElement={props.boundariesElement}
                hideArrow={false}
                buttonClassName="transparent-btn function-fragment-type"
                entries={props.addFragmentMenuEntries}
                onChange={this.onAddFragmentMenuSelection}
                disabled={props.disabled || !props.addFragmentMenuEntries.length}
                ref={this.onAddFragmentMenuRef}
            >
                <OEIcon code={OEIconCodes.func.addFragment}/>
            </OEPopoverMenuButton>
        );
    }

    renderButtons() {
        if(this.props.addButtonInHeader)    return null;

        return (
            <OEGroupControl className="function-controller-group-control-1">
                <OEIconButtonGroupControl
                    className="function-controller-buttons"
                    disabled={this.props.disabled}
                    buttons={[]}
                    onPressed={this.onButtonPressed}
                >
                    <OEPopoverMenuButton
                        className="transparent-btn last"
                        popoverClassName="with-backdrop"
                        controllerClassName="add-function-fragment-menu"
                        placement="right"
                        boundariesElement={this.props.boundariesElement}
                        hideArrow={false}
                        buttonClassName="transparent-btn function-fragment-type"
                        entries={this.state.addFragmentMenuEntries}
                        onChange={this.onAddFragmentMenuSelection}
                        disabled={!this.state.addFragmentMenuEntries.length}
                        ref={this.onAddFragmentMenuRef}
                    >
                        <OEIcon code={OEIconCodes.func.addFragment}/>
                    </OEPopoverMenuButton>

                </OEIconButtonGroupControl>

            </OEGroupControl>
        );
    }

    renderFragments()   {
        if(!this.state.func)    return null;
        return this.state.func.fragments.map((fragment, index) => 
            <OEFunctionFragmentCell
                key={index}
                moduleId={this.props.moduleId}
                popoverClassName="with-backdrop"
                popoverTargetId={this.props.popoverTargetId}
                boundariesElement={this.props.boundariesElement}
                showSeparator={index < this.state.func.fragments.length - 1}
                disabled={this.props.disabled}
                id={index}
                type={fragment.type}
                params={fragment.params}
                onChange={this.onFragmentChange}
                onDumpBtnPressed={this.onDumpFragmentBtnPressed}
            />
        );
    }
    
    render() {
        return  (
            <React.Fragment>
                <div className={'function-controller ' + this.props.className}>

                    <OEWidgetHeader
                        moduleId={this.props.moduleId}
                        className={this.props.headerClassName}
                        buttonClassName="transparent-btn"
                        icon={this.props.icon}
                        title={this.props.title}
                        titleId={this.props.titleId}
                        headerSeparator={this.props.headerSeparator}
                        centerBar={this.renderHeaderCenterBar}
                        onToggle={this.props.onToggle}
                        boundariesElement={this.props.boundariesElement}
                        disabled={this.props.disabled}
                        addFragmentMenuEntries={this.state.addFragmentMenuEntries}
                    />

                    {this.props.children}

                    <div className="function-controller-container compact">
                        {this.renderButtons()}

                        <CustomScrollbar
                            className="function-fragment-container compact"
                            horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                            verticalTrackVisiblity={CustomScrollbarTrackVisibility.always}
                        >
                            {this.renderFragments()}
                        </CustomScrollbar>

                    </div>

                </div>

            </React.Fragment>
        );
    }

    onChange(func)  {
        if(OEToolbox.shallowEqual(func, this.func, true)) return;

        if(this.props.onChange)   {
            this.props.onChange(this, func);
            return;
        }

        this.func = func
        this.setState({func: clone(this.func)});
        this.updateAddFragmentMenuEntriesState();
    }

    onButtonPressed(sender, id)   {

    }

    onAddFragmentMenuSelection(id)    {
        if(this.addFragmentMenuRef) this.addFragmentMenuRef.close();

        //
        let func = clone(this.func);
        if(!func)  func = {fragments: []};

        //
        let defaultParamsEntry = this.defaultFragmentParams.find(e => e.id === id);
        let params = defaultParamsEntry && defaultParamsEntry.params ? defaultParamsEntry.params : {};

        //
        func.fragments.push({type: id, params: params});
        this.onChange(func);
    }

    onDumpFragmentBtnPressed(sender, index) {
        if(!this.func || index < 0 || index >= this.func.fragments.length)  return;
        let func = clone(this.func);
        func.fragments.splice(index, 1);
        this.onChange(func);
    }

    onFragmentChange(sender, index, params) {
        if(!this.func || index < 0 || index >= this.func.fragments.length)  return;
        let func = clone(this.func);
        func.fragments[index].params = clone(params);
        this.onChange(func);
    }
}

OEFunctionController.defaultProps = OEFunctionProps.defaultProps;

OEFunctionController.propTypes = OEFunctionProps.propTypes;

//
export const OEFunctionPopoverController = OEPopover.coat(OEFunctionController, {
    noHeader:                   true,
}, {
    placement:                  'right',
    buttonClassName:            'transparent-btn',
    controllerClassName:        ''
}, {
    controllerClassName:        PropTypes.string
});

//
export default withIsOpenState(OEFunctionPopoverController);